/**
 * 运价维护列表「按需刷新」标记。
 *
 * keep-alive 场景下，从运价详情返回列表时默认不重新查询，直接保留原有列表数据与筛选结果；
 * 只有详情页里发生过新增/编辑/保存草稿等数据变更时，才标记一次，让列表在下次激活时刷新。
 */
const STORAGE_KEY_PREFIX = 'rate-management:list-refresh:'

/** 标记某个运价列表需要在下次激活时强制刷新 */
export const markRateListRefresh = (moduleKey: string) => {
  sessionStorage.setItem(`${STORAGE_KEY_PREFIX}${moduleKey}`, '1')
}

/** 读取并清除强制刷新标记，返回是否需要刷新 */
export const consumeRateListRefresh = (moduleKey: string): boolean => {
  const key = `${STORAGE_KEY_PREFIX}${moduleKey}`
  if (sessionStorage.getItem(key) !== '1') {
    return false
  }
  sessionStorage.removeItem(key)
  return true
}
